import { Pipe, PipeTransform } from '@angular/core';
import { TicketPL } from '../enums/ticket-pl';
import { Ticket } from '../models/entities/ticket';
import { TicketBatchTicket } from '../models/entities/ticket-batch-ticket';
import { TicketPipe } from './ticket-pipe';



@Pipe({
  name: 'ticket-batch-ticket-pipe'
})

export class TicketBatchTicketPipe implements PipeTransform {
  
  ticketPipe : TicketPipe = new TicketPipe();
  constructor(){}

  transform(ticketBatchTicket: TicketBatchTicket, field: string): any {

     if (field == 'ticket.progressLevel'){
       return this.ticketPipe.transform(ticketBatchTicket['ticket'], 'progressLevel')
    }

    return '...';
  }
}
